import 'velocity-animate'
import 'waypoints/lib/jquery.waypoints.min.js'
// import { wayPoint, velocityDownUp } from './js/general' no es opcion porque de todas maneras necesitaria incluir jquery dentro de general

var Isotope = require('isotope-layout');

(function ($) {

	function wayPoint(elemeway, delay, animationFun) {
		elemeway.waypoint(function () {
			var elem = $(this.element);
			setTimeout(function () {
				animationFun(elem);
			}, delay);
			this.destroy();
		}, {
			offset: '100%'
		});
	}

	function velocityDownUp(elem) {
		elem.velocity({ top: '0px', opacity: 1 }, { duration: 1500, easing: "easeOutQuart", delay: 100 });
	}

	function calculateHeight(aspectW, aspectH) {
		let winW = document.documentElement.clientWidth;
		let height = Math.round((winW * aspectH) / aspectW);
		return height;
	}

	function heightSlider(aspectW, aspectH) {
		let heightSliderDes = calculateHeight(aspectW, aspectH);
		$('#header-home').css('height', heightSliderDes + 'px');
	}

	function calcuHeightOnBaseElem(baseElemWidth, aspectW, aspectH, elem) {
		let heightElem = ((baseElemWidth * aspectH) / aspectW);
		elem.height(heightElem);
	}

	function setThreePost() {
		let baseElem = $('.content-boxed');
		if (window.matchMedia('(max-width: 768px )').matches) {
			var width = baseElem.width();
		} else {
			var width = baseElem.width() * 0.5 - 11; //minus padding
		}

		$('.post-box-upper .post-box-inner').each(function (index) {
			if (index == 0) {
				calcuHeightOnBaseElem(width, 587, 618, $(this));
			} else {
				calcuHeightOnBaseElem(width, 587, 298, $(this));
			}
		});
	}

	function threePost() {
		setThreePost();
		let sio = new Isotope('#upper-posts-wrapper', {
			itemSelector: '.post-box-upper',
			percentPosition: true,
			masonry: {
				columnWidth: '.upper-sizer'
			}
		});
	}

	function setHeightSlider() {
		let screenSize = $(window).width();
		if (screenSize >= 768) {
			heightSlider(1920, 695);
		} else if (screenSize < 768 && screenSize >= 480) {
			heightSlider(778, 900);
		} else {
			heightSlider(480, 800);
		}
	}

	function moreButton() {

		var my_offset = 0,
			ppp = 6,
			errormsg = ajax_posts.error,
			button = $('#button-load');

		button.on('click', function () {
			button.hide();
			$('#load-carga').show();
			$.ajax({
				url: ajax_posts.ajaxurl,
				type: 'post',
				data: { action: 'cargar_posts', ppp: ppp, offset: 15 + my_offset, isrnonce: button.data('identy') },
				success: function (result) {
					if (result.length) {
						$('#lower-posts-wrapper').append(result);
						wayPoint($("#lower-posts-wrapper .post-main"), 10, velocityDownUp);
					} else {
						$('#error-message').append(result.data);
					}
				},
				complete: function () {
					$('#load-carga').hide();
					button.show();
				},
				error: function () {
					$('#error-message').append(errormsg);
				}

			});//ajax
			my_offset = my_offset + 6;
		});//on
	}

	$(document).ready(function () {
		setHeightSlider();
		threePost();
		wayPoint($("#lower-posts-wrapper .post-main"), 10, velocityDownUp);
		moreButton();
	});//ready

	$(window).on('resize', function () {
		setHeightSlider();
		setThreePost();
	});

	$(document).on('change', '#lower-posts-wrapper', function () {
		wayPoint($("#lower-posts-wrapper .post-main"), 10, velocityDownUp);
	});

})(jQuery);